export default __webpack_public_path__ + "static/media/n1.d927daff.svg";